import React from 'react';

/**
 * Eduspire wordmark.
 *
 * @param {'ink'|'light'} tone  `ink` for light backgrounds, `light` for dark ones.
 */
export const Logo = ({ className = 'h-10', showText = true, tone = 'ink', compact = false }) => {
  const onDark = tone === 'light';

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        viewBox="0 0 200 200"
        className="h-full w-auto aspect-square shrink-0"
        role="img"
        aria-label="Eduspire"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="100" cy="100" r="94" fill="#FFFFFF" />
        <circle cx="100" cy="100" r="94" fill="none" stroke={onDark ? '#FFFFFF' : '#E6E2DA'} strokeWidth="4" />

        {/* Arched EDUSPIRE lettering */}
        <path id="eduspire-arc" d="M 32,104 A 70,70 0 0,1 168,104" fill="none" />
        <text
          fill="#D32F2F"
          style={{ fontFamily: 'Playfair Display, Georgia, serif', fontWeight: 700, fontSize: '24px', letterSpacing: '0.13em' }}
        >
          <textPath href="#eduspire-arc" startOffset="50%" textAnchor="middle">
            EDUSPIRE
          </textPath>
        </text>

        {/* Ascending figure */}
        <circle cx="98" cy="95" r="9" fill="#D32F2F" />
        <path
          d="M97 106 C85 116 70 129 65 143 C78 136 90 126 104 117 C100 136 92 156 86 167 C95 153 108 131 110 116 Z"
          fill="#D32F2F"
        />

        {/* Aspiration swoosh */}
        <path
          d="M62 156 C78 141 100 116 116 81 C110 99 94 131 75 149 C95 126 116 96 118 79 C120 71 120 63 119 56 C113 76 92 116 62 156 Z"
          fill="#1976D2"
        />

        {/* Spark */}
        <g transform="translate(121, 53)">
          <path d="M0 -15 L3 -3 L15 0 L3 3 L0 15 L-3 3 L-15 0 L-3 -3 Z" fill="#1976D2" />
          <path d="M0 -9 L2 -2 L9 0 L2 2 L0 9 L-2 2 L-9 0 L-2 -2 Z" fill="#64B5F6" />
        </g>

        <text
          x="100"
          y="175"
          textAnchor="middle"
          fill="#1565C0"
          style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '11px', letterSpacing: '0.22em' }}
        >
          A TOUCH OF CARE
        </text>
      </svg>

      {showText && (
        <span className="flex flex-col leading-none">
          <span
            className={`font-display text-[1.2rem] sm:text-[1.35rem] font-bold tracking-[-0.01em] ${
              onDark ? 'text-white' : 'text-ink-900'
            }`}
          >
            Eduspire
          </span>
          {!compact && (
            <span
              className={`text-[9px] sm:text-[10px] font-bold tracking-[0.16em] uppercase mt-1 ${
                onDark ? 'text-white/60' : 'text-ink-500'
              }`}
            >
              Career Development
            </span>
          )}
        </span>
      )}
    </span>
  );
};
